// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevel } from '@core/logger';
import { EnvironmentBase } from '@env/environment.base';
import { LoginBehaviour } from '@env/LoginBehaviour';

export const environment: EnvironmentBase = {
  name: 'pasm',
  MultiMandantConfigs: [
    {
      host: 'pas-kpt-smartportal-frontend-dev.pasmapps.de',
      pathToAssets: 'https://pas-kpt-smartportal-frontend-dev.pasmapps.de/assets/pasm',
    },
  ],
  baseUrl: 'https://pas-kpt-smartportal-backend-dev.pasmapps.de',
  production: true,
  logLevel: LogLevel.All,
  hmr: false,
  AadClientId: 'f9918b24-23ce-410d-9129-0f87f0d8bc5f',
  AadScope: 'https://pasb2cdev.onmicrosoft.com/pas-kpt-smartportal-backend-dev/API.ACCESS',
  AadAuthorityDomain: 'pasb2cdev.b2clogin.com',
  AadSignupSigninUrl:
    'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_KPT',
  AadEditprofileUrl: 'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  LoginButtonBehaviour: LoginBehaviour.B2C,
  buildNumber: '261015.0840',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
